import {
  sendMessage as baseSendMessage,
  waitingForMessage as baseWaitingMessage
} from '../../../../common/messaging';

const kind = "detailsCustomText";

const sendMessage = (dmMetricName, fieldName, fieldValue) => {
  baseSendMessage({
    to: "Angular",
    kind,
    dmMetricName,
    fieldName,
    fieldValue
  });
};

const waitingForMessage = (timeoutFunc, callback) => {
  return baseWaitingMessage((ev) => {
    if (ev.data.kind !== kind || ev.data.to !== "Angular") {
      return;
    }

    timeoutFunc(() => {
      callback && callback(ev.data);
    });
  });
};


export { sendMessage, waitingForMessage };
